import { history } from 'components/router/history';

const useNonBlockingLocation = () => {
    return history.location;
};

export { useNonBlockingLocation };
